import React, { useState, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import StepNavigation from '../../components/StepNavigation/StepNavigation';

import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';

import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';

import queryString from 'query-string';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import DpgStepOne from '../DpgStepOne/DpgStepOne';
import DpgStepTwo from '../DpgStepTwo/DpgStepTwo';
import DpgStepThree from '../DpgStepThree/DpgStepThree';
import DpgStepFour from '../DpgStepFour/DpgStepFour';
import DpgTemplateExamples from '../../components/DpgTemplateExamples/DpgTemplateExamples';

import styles from './DpgHome.module.css';

function DpgHome(props) {
  const [templatesData, setTemplatesData] = useState();
  const [defaultData, setDefaultData] = useState();
  const [loading, setLoading] = useState(true);

  if (!templatesData) {
    axios
      .get(process.env.REACT_APP_HOST + '/get-all-template-and-page-data')
      .then(function (response) {
        setTemplatesData(response.data.templatesData);
        setDefaultData(response.data.defaultData);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
        // always executed
      });
  }

  const [creativeLink, setCreativeLink] = useState({});
  const [checkedFilesInfo, setCheckedFilesInfo] = useState({});
  const [creativeZipLink, setCreativeZipLink] = useState({});
  const [previewWasViewed, setPreviewWasViewed] = useState({});
  const [stickyBarActive, setStickyBarActive] = useState(false);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { pathname, search } = useLocation();
  const { format } = queryString.parse(search);

  const examplesRef = useRef(null);
  const executeScroll = () => examplesRef.current?.scrollIntoView({ behavior: 'smooth' });

  // generate session id in 'App' instead of 'Home'
  if (!sessionStorage.getItem('sessionId')) {
    sessionStorage.setItem('sessionId', uuidv4());
  }

  const { path } = useRouteMatch();
  // form values
  const [campaignName, setCampaignName] = useState({ value: '', valid: true });
  const [contactName, setContactName] = useState({ value: '', valid: true });
  const [email, setEmail] = useState({ value: '', valid: true });
  const [ccEmails, setCcEmails] = useState([{ value: '', valid: true }]);
  const [landingPageURLs, setLandingPageURLs] = useState([{ value: '', valid: true }]);
  const [businessUnit, setBusinessUnit] = useState({
    country_english: 'Netherlands',
    country_native: 'Nederland',
    country_shorthand: 'NL',
    email: 'sales@weborama.nl',
  });
  const [comment, setComment] = useState('');

  // Custom introduction data for DPG route
  const dpgIntroductionData = {
    description:
      'Welcome to the DPG Media Easy Rich Media tool. ' +
      'To start, select a format in the dropdown menu above and then upload, preview and submit your high impact advertising format to use in DPG Admanager ' +
      'or on your DPG Media PMP or PG deal using the third party tag you will receive after submitting the creative.',
    additional_text: 'Download our easy-to-use PSD templates and get your ads ready in no time at all!\nA simple 3-step process',
    bullet_points: [
      'Choose your format, and dowload the .psd template.',
      'Upload and test your creative.',
      'Deliver your creative and book your received 3P tag in DPG admanager or on your DPG media PMP or PG deal.',
    ],
  };

  return (
    <div className={`${styles.homeContainer}`}>
      <Header />
      <div className={`${styles.body} ${isMobile && styles.mobile}`}>
        {!pathname.includes('stepFour') && <StepNavigation />}

        <div className={styles.stepContent}>
          {loading || !templatesData || !defaultData ? (
            <div className={styles.loadingIcon}></div>
          ) : (
            <Switch>
              <Route path={`${path}/stepOne`}>
                <DpgStepOne
                  templatesData={templatesData}
                  introductionData={format && templatesData[format] ? templatesData[format].template_info : dpgIntroductionData}
                  selectedFormat={format}
                  goToExamples={executeScroll}
                  stickyBarActive={stickyBarActive}
                  setStickyBarActive={setStickyBarActive}
                  modalIsOpen={modalIsOpen}
                />
              </Route>
              <Route path={`${path}/stepTwo`}>
                <DpgStepTwo
                  templatesData={templatesData}
                  selectedFormat={format}
                  creativeLink={creativeLink[format]}
                  setCreativeLink={setCreativeLink}
                  checkedFilesInfo={checkedFilesInfo[format]}
                  setCheckedFilesInfo={setCheckedFilesInfo}
                  previewWasViewed={previewWasViewed}
                  setPreviewWasViewed={setPreviewWasViewed}
                  setCreativeZipLink={setCreativeZipLink}
                />
              </Route>
              <Route path={`${path}/stepThree`}>
                {(() => {
                  // Helper function to find the correct key for creative links
                  const findCreativeKey = (obj) => {
                    const keys = Object.keys(obj);
                    // First try the exact format match
                    if (obj[format]) return format;
                    // Then try to find a key that contains relevant terms
                    const matchingKey = keys.find(
                      (key) => key.toLowerCase().includes('apto') || key.toLowerCase().includes('automated') || key.toLowerCase().includes('page_takeover')
                    );
                    return matchingKey || keys[0]; // fallback to first available key
                  };

                  const creativeKey = findCreativeKey(creativeLink);
                  const zipKey = findCreativeKey(creativeZipLink);

                  return (
                    <DpgStepThree
                      selectedFormat={format}
                      creativeLink={creativeLink[creativeKey]}
                      campaignName={campaignName}
                      setCampaignName={setCampaignName}
                      contactName={contactName}
                      setContactName={setContactName}
                      email={email}
                      setEmail={setEmail}
                      ccEmails={ccEmails}
                      setCcEmails={setCcEmails}
                      businessUnit={businessUnit}
                      landingPageURLs={landingPageURLs}
                      setLandingPageURLs={setLandingPageURLs}
                      setBusinessUnit={setBusinessUnit}
                      comment={comment}
                      setComment={setComment}
                      creativeZipLink={creativeZipLink[zipKey]}
                      defaultData={defaultData?.contact_page}
                    />
                  );
                })()}
              </Route>
              <Route path={`${path}/stepFour`}>
                <DpgStepFour />
              </Route>
            </Switch>
          )}
        </div>
        {/* Render DPG examples only when on step one and format has been selected */}
        {pathname.includes('stepOne') && format && templatesData && (
          <div ref={examplesRef}>
            <DpgTemplateExamples
              // examples={templatesData[format]?.template_info?.examples}
              selectedFormat={format}
            />
          </div>
        )}
      </div>
      <Footer stickyBarActive={stickyBarActive} setStickyBarActive={setStickyBarActive} />
    </div>
  );
}

export default DpgHome;
